module.exports = __webpack_public_path__ + "assets/img/sudare.037df623.svg";